export const rangeFilterProcessor = ({ query, key, filterData, filter }) => {
	let active = false;

	let selectedOption = null;
	const minVal = query[filter.minKey];
	const maxVal = query[filter.maxKey];
	const optionPostfix = filter.optionPostfix ? (' ' + filter.optionPostfix) : '';

	const minLabel = filter.minLabel ?? 'En Az';
	const maxLabel = filter.maxLabel ?? 'En Fazla';

	const filterActive = minVal || maxVal;

	const options = (filterData[key] ?? []).map(option => {
		const value = option.start + '-' + option.to;

		const item = {
			...option,
			label: option.name ?? `${option.start}${optionPostfix} - ${option.to}${optionPostfix}`,
			value: value,
		};

		if(minVal && maxVal && minVal.toString() === option.start.toString() && maxVal.toString() === option.to.toString()) {
			selectedOption = item;
		}

		return item;
	});

	const customOption = (filter.customEnabled || (!selectedOption && minVal || maxVal)) ? {
		label: filter.customLabel ?? 'Kendim Belirlemek İstiyorum',
		value: 'custom',
	} : null;

	if(customOption && (minVal || maxVal) && !selectedOption) {
		selectedOption = customOption;
	}

	return {
		...filter,
		key,
		minVal,
		maxVal,
		selectedOption,
		customOption,
		options,
		minLabel,
		maxLabel,
		active: filterActive,
		sumText: filterActive && (
			(!(minVal && maxVal) ? ((minVal ? minLabel : maxLabel) + ' ') : '') +
			(minVal ? minVal + optionPostfix : '') +
			(minVal && maxVal ? ' - ' : '') +
			(maxVal ? maxVal + optionPostfix : '')
		)
	}
}